import { createFileRoute } from '@tanstack/react-router'
import { AccountingPage } from '@/features/accounting'

export const Route = createFileRoute('/_authenticated/deposits-personal-view/')({
  component: () => (
    <AccountingPage
      kind='deposits'
      accountType='personal'
      mode='view'
      reviewPermission='deposit.personal.review'
      pageKey='personalView'
    />
  ),
})
